"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToSpeechServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
let TextToSpeechService = class TextToSpeechService extends client_1.RWSService {
    constructor(apiService) {
        super();
        this.apiService = apiService;
    }
    /**
     * Convert text to speech and get audio URL
     */
    async textToSpeech(request) {
        try {
            const response = await fetch('/api/audio/text-to-speech', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.apiService.token}`
                },
                body: JSON.stringify(request)
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            const audioBlob = await response.blob();
            return URL.createObjectURL(audioBlob);
        }
        catch (error) {
            console.error('Failed to convert text to speech:', error);
            return null;
        }
    }
    /**
     * Convert text to speech and return audio blob
     */
    async textToSpeechBlob(request) {
        try {
            const response = await fetch('/api/audio/text-to-speech', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.apiService.token}`
                },
                body: JSON.stringify(request)
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            return await response.blob();
        }
        catch (error) {
            console.error('Failed to convert text to speech:', error);
            return null;
        }
    }
    /**
     * Stream text to speech
     */
    async streamTextToSpeech(request, options = {}) {
        var _a, _b;
        try {
            const response = await fetch('/api/audio/stream-text-to-speech', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.apiService.token}`
                },
                body: JSON.stringify(request)
            });
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
            if (!response.body) {
                throw new Error('No response body for streaming');
            }
            const audioContext = new AudioContext();
            const source = audioContext.createBufferSource();
            // Read the stream
            const reader = response.body.getReader();
            const chunks = [];
            while (true) {
                const { done, value } = await reader.read();
                if (done)
                    break;
                chunks.push(value);
            }
            // Combine chunks
            const totalLength = chunks.reduce((acc, chunk) => acc + chunk.length, 0);
            const combined = new Uint8Array(totalLength);
            let offset = 0;
            for (const chunk of chunks) {
                combined.set(chunk, offset);
                offset += chunk.length;
            }
            // Decode and play
            const audioBuffer = await audioContext.decodeAudioData(combined.buffer);
            source.buffer = audioBuffer;
            source.connect(audioContext.destination);
            source.onended = () => {
                var _a;
                (_a = options.onEnd) === null || _a === void 0 ? void 0 : _a.call(options);
            };
            if (options.autoPlay !== false) {
                source.start();
                (_a = options.onPlay) === null || _a === void 0 ? void 0 : _a.call(options);
            }
            return true;
        }
        catch (error) {
            console.error('Failed to stream text to speech:', error);
            (_b = options.onError) === null || _b === void 0 ? void 0 : _b.call(options, error);
            return false;
        }
    }
    /**
     * Validate text for TTS
     */
    validateText(text) {
        const maxLength = 5000; // 5000 characters limit
        if (!text || text.trim().length === 0) {
            return {
                valid: false,
                error: 'Text cannot be empty'
            };
        }
        if (text.length > maxLength) {
            return {
                valid: false,
                error: `Text exceeds ${maxLength} character limit`
            };
        }
        return { valid: true };
    }
    /**
     * Optimize text for speech synthesis
     */
    optimizeTextForSpeech(text) {
        return text
            // Replace common abbreviations
            .replace(/\bDr\./gi, 'Doctor')
            .replace(/\bMr\./gi, 'Mister')
            .replace(/\bMrs\./gi, 'Missus')
            .replace(/\bMs\./gi, 'Miss')
            .replace(/\betc\./gi, 'etcetera')
            .replace(/\bi\.e\./gi, 'that is')
            .replace(/\be\.g\./gi, 'for example')
            // Handle URLs
            .replace(/https?:\/\/[^\s]+/gi, 'web link')
            // Handle emails
            .replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi, 'email address')
            // Clean up multiple spaces
            .replace(/\s+/g, ' ')
            .trim();
    }
};
exports.TextToSpeechServiceInstance = TextToSpeechService;
exports.TextToSpeechServiceInstance = TextToSpeechService = __decorate([
    __param(0, client_1.ApiService),
    __metadata("design:paramtypes", [typeof (_a = typeof client_1.ApiServiceInstance !== "undefined" && client_1.ApiServiceInstance) === "function" ? _a : Object])
], TextToSpeechService);
exports.default = TextToSpeechService.getSingleton();
